var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('div',{staticStyle:{"position":"relative","overflow":"hidden","padding-top":"calc(100vh - 56.875px)"}},[_c('embed',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"src":"https://doc.quanteec.com/"}})])])
}]

export { render, staticRenderFns }